<template>
    <div class="">
        <!-- <right-data :Pdatas='infoData'>
            <pre slot="q_code">
                    {{JSON.stringify(responseCode, null, 4)}}
                </pre>
            <pre slot="r_code">
                    {{JSON.stringify(responseCode, null, 4)}}
                </pre>
        </right-data> -->
    </div>
</template>

<script>
// import rightData from "../rightData.vue"

export default {
    name: '',
    // components: {
    //     'right-data': rightData,
    // },
    data() {
        return {
            responseCode: {
                "Code": 1,
                "Data": [{
                    "BussinessID": null,
                    "TraceID": "6d025700bb79458ca73ae5051cf626ab",
                    "PICMID": "jBBn1JzXBMf1rjE4GjGjrMjFF8W5InJFSqwmB04DjXc=",
                    "Code": 638,
                    "IsSuccess": false,
                    "FailReason": "[638已经领取过",
                    "VCode": "981765754626",
                    "EnableTime": "2017-01-01T00:00:00",
                    "OverdueTime": "2017-04-29T23:59:59"
                }],
                "Message": "成功"
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取停车费用接口",
                t_url: "trade/getParkFee",
                p_url: "trade/getParkFee/getParkFee/getParkFee",
                frequency: "实时",
                pattern: "智慧停车开放平台提供接口，第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'cmd', info2: '是', info3: 'String', info4: 'cmd=getParkFee' },
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号，如果不传，则在整个系统按车牌或卡号搜索' },
                        { info1: 'carCode', info2: 'carCode跟cardCode和parkingCode三选一', info3: 'String', info4: '车牌编号' },
                        { info1: 'cardCode', info2: 'carCode跟cardCode和parkingCode三选一', info3: 'String', info4: '停车卡编号' },
                        { info1: 'parkingCode', info2: 'carCode跟cardCode和parkingCode三选一', info3: 'String', info4: '停车流水号' },
                        { info1: 'needPayQrCode', info2: '否', info3: 'Integer', info4: '0否，1是' },
                        { info1: 'couponList', info2: '否', info3: 'JsonArray', info4: '查询的优惠列表' }]
                }, {
                    titleName: '副标题',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '接口调用结束的回调函数' },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '说明td' },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', sub: { 'kk': 222 } },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '说明td' },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '说明td' },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '说明td' },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '说明td' }]
                }],
                R_params: [{
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'cardCode', info2: '是', info3: 'String', info4: '停车卡编号' },
                        { info1: 'enterDate', info2: '是', info3: 'String', info4: 'yyyyMMddHHmmss进场时间' },
                        { info1: 'chargeDate', info2: '是', info3: 'String', info4: 'yyyyMMddHHmmss计费时间' },
                        { info1: 'parkingTime', info2: '是', info3: 'Integer', info4: '停车时长，分钟为单位' },
                        { info1: 'parkingFee', info2: '是', info3: 'Decimal', info4: '此次停车的总费用，单位元' },
                        { info1: 'shouldPayValue', info2: '是', info3: 'Decimal', info4: '需缴费金额，单位元' },
                        { info1: 'paidValue', info2: '是', info3: 'Decimal', info4: '此次停车已缴金额，单位元' },
                        { info1: 'discountedValue', info2: '是', info3: 'Decimal', info4: '此次停车已优惠金额，单位元' },
                        { info1: 'currDisValue', info2: '是', info3: 'Decimal', info4: '本次优惠金额，单位元' },
                        { info1: 'otherAttr', info2: '是', info3: 'JSONObject', info4: '额外信息，缴费时传回，用于扩充其他需要的信息。现有一属性，券列表' },
                        { info1: 'carChargeType', info2: '是', info3: 'Integer', info4: '0混合类型，1临时车，2时间VIP，3储值VIP，4计次VIP，5黑名单，6访客，7预定车位车辆，8共享车位车辆，9红名单，混合类型表示整次停车包括多个类型，如临时车-时间VIP' },
                        { info1: 'carChargeDesc', info2: '是', info3: 'String', info4: 'carChargeType对应具体类型名称如临时车、半年卡、储值卡等混合类型展示格式【类型1】-【类型2】，如临时车-半年卡' },
                        { info1: 'payQrCode', info2: '是', info3: 'Decimal', info4: '支付二维码Base64编码格式' },
                        { info1: 'couponList ', info2: '否', info3: 'JsonArray', info4: '对应查询时的优惠响应（目前只支持传输一个优惠）' }
                    ]
                }, {
                    titleName: '副标题',
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }, {
                    titleName: '副标题',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '接口调用结束的回调函数' },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '说明td' },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', sub: { 'kk': 222 } },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '说明td' },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '说明td' },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '说明td' },
                        { info1: '参数名td', info2: '是否必填td', info3: '类型td', info4: '说明td' }]
                }, {
                    titleName: '副标题',
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
                codeStatus: [{
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/rightDoc_bk.vue